import { sessionConstants } from '../constants';

export function sessionStatus (state = {}, action) {
    switch (action.type) {
      case sessionConstants.SESSION_STATUS_REQUEST:
        return { 
          loading:action.res
         };
      case sessionConstants.SESSION_STATUS_SUCCESS:  
      return {
          ...state,
          sessionStatus: action.res,
          loading:false,
        };
      case sessionConstants.SESSION_STATUS_FAILURE:
        return {
          error: action.error,
          loading:false
        };
      default:
        return state
    }
  }


// WEBPACK FOOTER //
// ./src/store/reducers/sessionStatus.reducer.js